/*global window, FB */

/**
 * View model constructor for Facebook login
 */
app.registerConstructor("LinkedinLogin", function () {
    const self = this;
    this.trace = false;

    this.initLinkedin = function () {
      try{
          IN.User.logout();
      }
      catch(e){
        app.console.log("fail to Logout on load");
      }
      self.attachLoginButton('a.btn-linkedin');
    };

    this.attachLoginButton = function (selector) {
        $(selector).click(function () {
           IN.UI.Authorize().params({"scope":["r_basicprofile", "r_emailaddress"]}).place();
           IN.Event.on(IN, "auth", app.vm.LinkedinLogin.onLinkedInAuth);
           IN.User.setAuthorized(true);
           //IN.Event.on(IN, "logout", onLinkedInLogout);
        });
    };

this.onLinkedInAuth = function () {
   IN.API.Profile("me").fields("id,firstName,lastName,emailAddress,publicProfileUrl,positions:(company:(name,type,industry,ticker),title,summary,startDate,endDate,isCurrent),industry,location:(name,country:(code)),dateOfBirth,headline,maidenName,currentShare,summary,pictureUrls::(original),pictureUrl,specialties,formattedPhoneticName").result(function (me) {
   var profile = me.values[0];

   var token = IN.ENV.auth.oauth_token;

   var imageURL;
   //console.log(IN.ENV.auth.oauth_token);
   if (!profile.pictureUrls || profile.pictureUrls._total=="0") {
      // No picture provided
      imageURL = profile.pictureUrl;
   } else {
      imageURL = profile.pictureUrls.values[0];
   };
  //app.vm.SocialLoginCommon.doRemoteLogin(token, response.id, response.first_name, response.last_name, response.email, "Facebook", response.link, response);

   app.vm.SocialLoginCommon.doRemoteLogin(token, profile.id, profile.firstName, profile.lastName, profile.emailAddress, 'LinkedIn', profile.publicProfileUrl, profile, imageURL);

   });
}

}).createVM();
